export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getPositionListlAction";
    Actions["GET_DETAIL"] = "getPositionDetailAction";
    Actions["POST_DATA"] = "postPositionAction";
    Actions["UPDATE_DATA"] = "putPositionAction";
    Actions["DELETE_DATA"] = "deletePositionAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_POSITION_LIST"] = "setPositionListMutation";
    Mutations["SET_POSITION_LIST_LOADING"] = "setPositionListLoadingMutation";
    Mutations["SET_POSITION_LIST_PAGINATION"] = "setPositionListPaginationMutation";
})(Mutations || (Mutations = {}));
